import {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import { getFirstLinkedAssetOrDefault } from '@r-and-a-shared-ui/common-kontent-client/utils';
import { getFirstMappedLinkedItemOrDefault } from './utils/component-mapping-helpers';

export const logo = (
  entry: MEMBERSHIP_MODELS.Logo | PLAYER_PORTALS_MODELS.Logo,
) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements } = entry || {};

  const logoImage = getFirstLinkedAssetOrDefault(elements?.logo_image as any);
  const mobileLogoImage =
    'mobile_logo_image' in elements
      ? getFirstLinkedAssetOrDefault(elements?.mobile_logo_image as any)
      : undefined;

  return {
    logoImage: logoImage?.url,
    logoDescription: logoImage?.description,
    resource: getFirstMappedLinkedItemOrDefault(elements?.resources as any),
    mobileLogoImage: mobileLogoImage?.url,
    mobileLogoDescription: mobileLogoImage?.description,
  };
};

export default logo;
